"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataService = void 0;
const tslib_1 = require("tslib");
const apiRoutes_1 = require("../../utils/apiRoutes");
const excludeInvalidParams_1 = require("../../utils/excludeInvalidParams");
const Base_1 = require("../Base");
class MetadataService extends Base_1.BaseService {
    fetchCountries(locale) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { countries } = yield this.request({
                url: (0, apiRoutes_1.fetchCountriesMetadataApiUrl)(),
                method: 'get',
                params: (0, excludeInvalidParams_1.excludeInvalidParams)({
                    locale,
                }),
            });
            return countries;
        });
    }
    fetchStates(locale, countryCode) {
        return this.request({
            url: (0, apiRoutes_1.fetchStatesMetadataApiUrl)(),
            method: 'get',
            params: (0, excludeInvalidParams_1.excludeInvalidParams)({
                locale,
                countryCode,
            }),
        }).then(({ states }) => states);
    }
    fetchLanguages({ locale }) {
        return this.request({
            url: (0, apiRoutes_1.fetchLanguagesMetadataApiUrl)(),
            method: 'get',
            params: (0, excludeInvalidParams_1.excludeInvalidParams)({
                locale,
            }),
        }).then(({ languages }) => languages);
    }
    fetchMultilingualLanguages() {
        return this.request({
            url: (0, apiRoutes_1.fetchMultilingualLanguagesUrl)(),
            method: 'get',
        });
    }
}
exports.MetadataService = MetadataService;
//# sourceMappingURL=index.js.map